/**
 * @typedef { import('./EventWebinarDetail').EventWebinarDetail } EventWebinarDetail
 */

import styled from 'styled-components';
import { useLocalization } from '../../custom-hooks/useLocalization';
import Accordion from '../../shared/Accordion';
import { useEventWebinarContext } from './EventWebinarContext';

const CpeCreditsStyle = styled.div`
  margin-block: 4rem;
`;

const CpeCount = styled.p`
  font-size: 2rem;
  line-height: 2.4rem;
  color: var(--charcoal);
  margin-block: 0;
  font-weight: 800;
`;

const CpeCreditNotes = styled.p`
  font-size: 1.6rem;
  margin-block: 0;
  line-height: 2.4rem;
  font-weight: 400;
`;

const CpeDescription = styled.div`
  &.cpe-description.no-top-bottom {
    padding-bottom: 0;
  }

  p {
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.4rem;
    margin-block: 0;
  }
`;

export const CpeCredits = () => {
  const { cpeCount, cpeCreditNotes } = useEventWebinarContext();

  return (
    <CpeCreditsStyle>
      <CpeCount>{cpeCount}</CpeCount>
      <CpeCreditNotes>{cpeCreditNotes}</CpeCreditNotes>
    </CpeCreditsStyle>
  );
};

/**
 * @param {Pick<EventWebinarDetail, 'cpeInformation'>}
 * @returns {ReactElement}
 */
export const CpeInformation = () => {
  const { cpeInformation, programLevel, delivery, prerequisites, advancedPrep } =
    useEventWebinarContext();
  const { resourceStrings } = useLocalization();

  const AccordionContent = () => (
    <>
      <CpeDescription className="cpe-description no-top-bottom">
        {delivery && <CpeCreditNotes>Delivery: {delivery}</CpeCreditNotes>}
        {prerequisites && <CpeCreditNotes>Prerequisites: {prerequisites}</CpeCreditNotes>}
        {advancedPrep && <CpeCreditNotes>Advanced Prep: {advancedPrep}</CpeCreditNotes>}
        {programLevel && <CpeCreditNotes>Program Level: {programLevel}</CpeCreditNotes>}
      </CpeDescription>
      <div dangerouslySetInnerHTML={{ __html: cpeInformation }}></div>
    </>
  );

  return (
    <Accordion
      className="accordion-item"
      pageTitle={resourceStrings['bdO.EventsWebinars.CPEInformationTitle']}
      index={0}
    >
      <AccordionContent />
    </Accordion>
  );
};
